const piWriterHu = {
	piWriterTable: 'PI Writer',
	piWriterLog: 'PI Writer Log',
	piWriterEditForm: 'PI Writer',
	name: 'Name',
	dataServerName: 'Data Server Name',
	hostname: 'Hostname',
	user: 'User',
	password: 'Password',
	timezone: 'Timezone',
	type: 'Type',
	tagName: 'Tag Name',
	expression: 'Expression',
	basic: 'Basic',
	fields: 'Fields',
	userGroup: 'User Group'
};

export default piWriterHu;